import React, { useMemo } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

const CircleProgress = ({ numOfChars, max, warningPercentage, maxReachedClass, warningClass, className }) => {
  const warningGauge = useMemo(() => (warningPercentage * max) / 100, [warningPercentage, max]);
  return (
    <svg
      className={`description-counter ${className}`}
      viewBox="0 0 36 36"
    >
      <path
        stroke="#7373737"
        className="circle"
        style={{ strokeDasharray: "100, 100" }}
        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
      />
      <path
        className={classNames("circle-progress", {
          [maxReachedClass]: numOfChars >= max,
          [warningClass]: numOfChars > warningGauge && numOfChars < max,
        })}
        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
        style={{ strokeDasharray: `${(numOfChars * 100) / max}, 100` }}
      />
    </svg>
  );
};

CircleProgress.propTypes = {
  numOfChars: PropTypes.number,
  max: PropTypes.number,
  warningPercentage: PropTypes.number,
  maxReachedClass: PropTypes.string,
  warningClass: PropTypes.string,
  className: PropTypes.string,
};

CircleProgress.defaultProps = {
  warningPercentage: 80,
  className: "",
};

export default CircleProgress;
